import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { formValueSelector, reduxForm } from 'redux-form';
import cx from "classnames"

import ViewSubCategory from '../ViewSubCategory/ViewSubCategory';
import ReviewYourRequestBanner from '../../../ReviewYourRequestBanner/ReviewYourRequestBanner';
import SubCategorySkeleton from '../../../Skeleton/Categories/SubCategorySkeleton/SubCategorySkeleton';

import messages from '../../../../locale/messages';

import useQueryResponse from '../../../../lib/hooks/useQueryResponse';
import getSubCategories from './getSubCategories.graphql';

import noResult from "../../../../../public/Icons/noResults.svg"

import bt from '../../../commonStyle.css';
import s from './SubCategory.css';


function SubCategory(props) {

    const { id, pricingType, preferredCurrency, lat, lng, ordersData, change } = props

    const { data, loading } = useQueryResponse({
        query: getSubCategories,
        variables: {
            categoryId: id,
            lat: lat,
            lng: lng,
            requestCurrency: preferredCurrency,
            userType: 1
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
    const [orders, setOrders] = useState([])

    useEffect(() => {
        if (ordersData?.length === 0) {
            setOrders([])
        }
    }, [ordersData])


    const handleAddOrder = async (subCategoryData) => {
        const newOrders = [
            ...orders,
            { ...subCategoryData, quantity: subCategoryData.quantity ?? 1 }
        ];
        setOrders(newOrders);
        await change('orderData', newOrders);
    };

    const handleRemoveOrder = async (id) => {
        const newOrders = orders.filter(o => o.subCategoryId !== id);
        setOrders(newOrders);
        await change('orderData', newOrders);
    };

    const addOrderQuantity = async (data) => {
        const newOrders = orders.map(o =>
            o.subCategoryId === data.id
                ? { ...o, quantity: o.quantity + 1 }
                : o
        );
        setOrders(newOrders);
        await change('orderData', newOrders);
    };

    const removeOrderQuantity = async (data) => {
        const newOrders = orders.map(o =>
            o.subCategoryId === data.id
                ? { ...o, quantity: o.quantity - 1 }
                : o
        );
        setOrders(newOrders);
        await change('orderData', newOrders);
    };

    const resetForm = async () => {
        setOrders([]);
        await change('orderData', []);
    };
    if (loading) {
        return <SubCategorySkeleton />
    }
    return (
        <>
            {data?.getSubCategories?.results?.length > 0 &&
                <div className={s.subCategoryListContainer}>
                    {data?.getSubCategories?.results?.map((item, index) => {
                        let existsData, orderQuantity;
                        existsData = orders?.find(o => o.subCategoryId == item.id);
                        orderQuantity = orders?.find(o => o.subCategoryId == item.id);
                        return (
                            <div key={index} className={s.subCategoryListItem}>
                                <ViewSubCategory
                                    key={index}
                                    data={item}
                                    image={item.image}
                                    name={item?.name}
                                    description={item?.description}
                                    pricingType={pricingType}
                                    basePrice={item.pricingDetails.basePrice || ''}
                                    currency={item.pricingDetails.currency}
                                    multiplierValue={item.pricingDetails.multiplierValue}
                                    isOrderExist={existsData ? true : false}
                                    quantity={orderQuantity?.quantity}
                                    handleAddOrder={handleAddOrder}
                                    handleRemoveOrder={handleRemoveOrder}
                                    addOrderQuantity={addOrderQuantity}
                                    removeOrderQuantity={removeOrderQuantity}
                                />
                            </div>
                        )
                    })}
                </div>
            }
            {
                data?.getSubCategories?.results?.length === 0 || data?.getSubCategories?.results === null && <div className={cx(s.subCategoryNoListItem, bt.textAlignCenter)}>
                    <div className={s.subCategoryNoListImgContainer}>
                        <img src={noResult} alt="subCategoryNoListImgContainer" />
                    </div>
                    <FormattedMessage {...messages.noResult} />
                </div>
            }
            {
                data?.getSubCategories?.results?.length > 0 && ordersData?.length > 0 && <ReviewYourRequestBanner resetForm={resetForm} currentCategoryId={id} requestCurrency={preferredCurrency} />
            }
        </>
    )

}

SubCategory = reduxForm({
    form: 'BookingForm',
    destroyOnUnmount: true
})(SubCategory);

const selector = formValueSelector('BookingForm');

const mapState = (state) => ({
    ordersData: selector(state, 'orderData'),
});


export default injectIntl(withStyles(bt, s)(connect(mapState, {})(SubCategory)))